import React, { ReactElement, ReactNode } from 'react';
import { Collapse, Box } from '@mui/material';

import Search, { ISearchProps } from './Search';

export interface IRecordManagement {
  children: React.ReactNode;
}

type InstanceState = {
  showFilters: boolean;
};

export default class RecordManagement extends React.Component<IRecordManagement> {
  state: InstanceState = {
    showFilters: false,
  };

  toggleFilters = () => {
    this.setState({ showFilters: !this.state.showFilters });
  };

  wrapSearch = (search: any, hasFilters: boolean) => {
    return React.cloneElement(
      search,
      {
        ...search.props,
        hasFilters,
        showFilters: this.state.showFilters,
        toggleFilters: this.toggleFilters,
      },
      [],
    );
  };

  render() {
    let search: ReactElement<ISearchProps> | null = null;
    const remainingChildren: ReactNode[] = [];

    React.Children.forEach(this.props.children, (child: ReactElement<any>) => {
      if (child.type === Search) {
        search = child;
      } else {
        remainingChildren.push(child);
      }
    });

    const filters = React.Children.map(remainingChildren, (child) => <Box m={2}>{child}</Box>);
    const hasFilters = remainingChildren.length > 0;

    const wrappedSearch = search !== null ? this.wrapSearch(search, hasFilters) : null;

    return (
      <>
        {wrappedSearch}
        <Collapse in={this.state.showFilters} timeout='auto'>
          <Box p={3} display='flex' flexWrap='wrap'>
            {filters}
          </Box>
        </Collapse>
      </>
    );
  }
}
